import { createSlice } from "@reduxjs/toolkit";

export const farmDetailedWeather = createSlice({
  name: "farm_detailed_weather",
  initialState: {
    value: {
      status: false,
      data: { longitude: 0, latitude: 0 },
    },
  },
  reducers: {
    updateFarmWeather: (state, action) => {
      state.value.status = true;
      state.value.data.longitude = action?.payload?.longitude;
      state.value.data.latitude = action?.payload?.latitude;
    },
    resetFarmWeather: (state, action) => {
      state.value = {
        status: false,
        data: { longitude: 0, latitude: 0 },
      };
    },
  },
});

export const { updateFarmWeather, resetFarmWeather } =
  farmDetailedWeather.actions;

export default farmDetailedWeather.reducer;
